/** Typy tercov pri strelbe */
export enum ShootingTargetsTypes {

  prone = 'Prone',
  standing = 'Standing'

}
